/**
 * Constantes UI del flujo de pantalla Catálogo (etiquetas de origen, formato moneda).
 */
import { formatMoney } from '../../shared/format/public-api';

export const sourceLabels = {
  local: 'Ya cargado',
  supabase_cache: 'Guardado',
  open_food_facts: 'Datos de internet',
} as const;

/**
 * Moneda canónica (`$1.500`, sin espacio) delegada a shared/format.
 * Se conserva la forma `{ format }` porque los componentes reciben el formatter por prop.
 */
export const currencyFormatter: { format: (value: number) => string } = { format: formatMoney };

